import {
    deserialisePeople,
    Person
} from '@api/lendingAPI/CustomerStateAPIHelper';
import {
    fetchGetStateByStateKey,
    GetStateByStateKeyResponse
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

import { useStateKey } from '../../../../iwQueryClient/useStateKey';

export type TCompanyShareholdersPeopleData = {
    people: Person[];
};

export const useGetCompanyShareholders = (): TCompanyShareholdersPeopleData => {
    const stateKey = useStateKey();

    const { data: application_people } = useQuery({
        queryKey: ['customer_state', stateKey],
        queryFn: () => fetchGetStateByStateKey({ stateKey }),
        select: (data: GetStateByStateKeyResponse) =>
            data!.data!.application!.people,
        suspense: true
    });

    if (!application_people) {
        throw new Error();
    }

    const deserialisedPeople = deserialisePeople(application_people);

    return {
        people: deserialisedPeople
    };
};
